export default {"src":"/_next/static/media/icon-swiper.a9f1aadf.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};